import { PostConnectionQuery } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import { ArticleQuery } from '../../app/pageClient';
import { layout } from '../../styles/layout';
import '../../styles/tokens.stylex';
import { color, spacing } from '../../styles/tokens.stylex';
import { typography } from '../../styles/typography';
import { PageSection } from '../PageSection';
import { RichText } from '../RichText';
import ArticleListClient from './ArticleListClient';
import { ControlledLink, LinkProvider } from './ControlledLink';
type ArticleListProps = {
  data: unknown;
  articleQuery?: ArticleQuery;
  isClient?: boolean;
};
type ArticleServerProps = {
  data?: unknown;
  articleData?: PostConnectionQuery;
};
export function ArticleList({
  data,
  articleQuery,
  isClient,
  ...props
}: ArticleListProps) {
  if (!articleQuery) {
    return null;
  }
  return isClient ? <ArticleListClient articleQuery={articleQuery} {...props} /> : <ArticleListServer articleData={articleQuery.data} {...props} />;
}
const _temp = {
  "x-default-marker": "x-default-marker",
  $$css: true
};
export function ArticleListServer({
  articleData
}: ArticleServerProps) {
  return <PageSection>
      <ul className="x1717udv x1ghz6dp xe8uvvx xrvj5dj xgwy2zt x1mhrlx8">
        {articleData?.postConnection.edges?.map((article, i) => {
        const {
          node
        } = article || {};
        const lastUpdated = article?.node?.publishDate ? new Date(article?.node?.publishDate).toLocaleDateString('en-AU', {
          year: '2-digit',
          month: 'short',
          day: 'numeric'
        }) : undefined;
        return node ? <LinkProvider key={node.id} className="x15arrhr x1hssuek xrvj5dj x1clt5hq x171aqo1">
              <article {...stylex.props(_temp, layout.contentCard, sx.card)}>
                <div className="xrvj5dj x1clt5hq x1c4oqta x3ybb33 xm3ov88">
                  <ControlledLink href={`/blog/${node._sys.breadcrumbs.join('/')}`} {...stylex.props(typography.heading2, sx.heading)}>
                    <h1 {...stylex.props(typography.heading2, sx.heading)} data-tina-field={tinaField(node, 'title')}>
                      {node.title}
                    </h1>
                  </ControlledLink>
                  <p {...stylex.props(typography.small)} data-tina-field={tinaField(node, 'author')}>
                    {`${lastUpdated} by ${node.author?.staffName}`}
                  </p>
                </div>
                <RichText data-tina-field={tinaField(node, 'peg')} className="xm3ov88">
                  {node.peg}
                </RichText>
                <div className="x1n2onr6 x1clqncf x1ficeh5 x17he1k x7giv3 x8mr9mu">
                  {node.alt && node.image && <Image alt={node.alt} src={node.image} fill className="xl1xv1r x1sotwcg xgsjgxe x1so62im x1g0ag68 x1c071of x1pl3064" data-tina-field={tinaField(node, 'image')} sizes="640px" />}
                </div>
              </article>
            </LinkProvider> : null;
      })}
      </ul>
    </PageSection>;
}
const sx = {
  card: {
    k1xSpc: "xrvj5dj",
    k9llMU: "x1clt5hq",
    kbNqZ1: "x1pte3vf",
    kLKAdn: "xexx8yu",
    kg3NbH: "xnjsko4",
    kumcoG: "x3nbd3",
    kkrTdU: "x1ypdohk",
    kWkggS: "x1xlpcrp xrzbrjk",
    kmkexE: "xgsjgxe",
    k6sLGO: "x1so62im",
    k3nNDw: "x1g0ag68",
    k3aq6I: "x1c071of x1orckw4",
    $$css: true
  },
  heading: {
    kybGjl: "x1hl2dhg xtavv6l",
    kSGwAc: "xkh2ocl",
    $$css: true
  }
};